export default __webpack_public_path__ + "static/media/level-complete.3d24a343.svg";